import { useTranslation } from 'react-i18next'

const useTranslator = () => {
  const { t } = useTranslation()

  const translate = (text: string, state?: { [key: string]: string }): string => {
    return t(text, state)
  }

  return {
    translate,
  }
}

export default useTranslator
